// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------
import React, { useState } from "react";
import notification from "antd/lib/notification";
// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { Button } from "components/Common/Button";
import { FormErrorTag } from "components/Common/Form/FormErrorTag";
import ImageUpload from "components/ImageUpload";
// -----------------------------------------------------------------------------
// Utils and Styles
// -----------------------------------------------------------------------------
import StyledUploadAssetsForm from "./styles";
import { useGetS3SignedUrlMutation, useGetDomainGymQuery } from "store/api/api";
import axios from "axios";
import { useParams } from "react-router";
import { maxImageAssetSize, imageSizeLimitError } from "helpers/constants";
import "./styles.scss";

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const UploadThumbnailForm = ({ nextStep, previousStep, values, setValues, loading }) => {
	const { gym } = useParams();
	const domainGymResponse = useGetDomainGymQuery(gym);
	const domainGymId = domainGymResponse.data?.id;
	const [thumbnailFile, setThumbnailFile] = useState(values?._thumbnail || null);
	const [nextLoading, setNextLoading] = useState(false);
	const [getS3SignedUrlTrigger] = useGetS3SignedUrlMutation();
	const blobToFile = async (blob) => {
		const blobToFile = new File([blob], "workoutThumbnail.png", {
			type: "image/png",
		});

		return blobToFile;
	};

	const uploadAsset = async (response, thumbnailFile) => {
		const formData = new FormData();

		const headers = {
			"Content-Type": "multipart/form-data",
		};

		for (const field in response.fields) {
			formData.append(field, response.fields[field]);
		}

		formData.append("file", thumbnailFile);

		try {
			await axios.post(response.url, formData, { headers });
		} catch (error) {
			notification.error({
				message: "Error Uploading Image",
				description: "Please try again",
			});
		}
	};

	const uploadImageToS3 = async () => {
		const mimeMap = {
			"image/jpeg": "jpg",
			"image/png": "png",
		};
		const fileType = mimeMap[thumbnailFile.type] ?? "png";
		const s3KeyThumbnail = `assets/${domainGymId}/thumbnail-${new Date().getTime()}.${fileType}`;
		const s3SignedResponse = await getS3SignedUrlTrigger({ key: s3KeyThumbnail, type: "image" });
		await uploadAsset(s3SignedResponse.data.response, thumbnailFile);
		const fullS3ThumbNail = `${s3SignedResponse.data.response.url}/${s3KeyThumbnail}`;
		return fullS3ThumbNail;
	};

	const handleClickNext = async () => {
		setNextLoading(true);
		const thumbnail = await uploadImageToS3();
		await nextStep({ image_url: thumbnail, thumbnail });
		setNextLoading(false);
	};

	const onImageCancel = () => {
		setValues((v) => ({ ...v, _thumbnail: null }));
		setThumbnailFile(null);
	};

	const onSelectImage = async (blob) => {
		const file = await blobToFile(blob);
		setThumbnailFile(file);
		setValues((v) => ({ ...v, _thumbnail: file }));
	};

	const containerStyles =
		window.innerWidth < 575
			? { width: 264, height: 0.6 * 264, maxHeight: 0.6 * 264, minHeight: 0.6 * 264 }
			: { width: 440, height: 264 };

	return (
		<StyledUploadAssetsForm>
			<div className="sb-upload-assets-form">
				<div className="sb-upload-assets-form__upload">
					<ImageUpload
						className="sb-upload-assets-form__upload__input"
						onSave={onSelectImage}
						onCancel={onImageCancel}
						type="image"
						selected={thumbnailFile}
						title=" "
						aspectRatio={300 / 180}
						extraStyles={{ width: "100%", height: "100%" }}
						containerStyles={containerStyles}
						sizeLimit={{
							limit: maxImageAssetSize,
							error: imageSizeLimitError,
						}}
					/>
					{thumbnailFile === undefined && <FormErrorTag text="Thumbnail required" />}
				</div>
				<div className="sb-workout-music-form__actions">
					<Button
						className="cancel-btn"
						size="small"
						type="button"
						onClick={() => previousStep()}
						data-id="btnUploadAssetBack"
					>
						Previous
					</Button>
					{thumbnailFile && (
						<Button
							type="submit"
							onClick={handleClickNext}
							className="sb-upload-assets-form__form__button primary-filled"
							loading={loading || nextLoading}
							disabled={loading}
							data-id="btnUploadAssetSubmit"
						>
							Next
						</Button>
					)}
				</div>
			</div>
		</StyledUploadAssetsForm>
	);
};

export default UploadThumbnailForm;

